// 封装的本地存储的方法
export default {
  get(key) {
    return JSON.parse(localStorage.getItem(key)); //获取
  },
  set(key, val) {
    localStorage.setItem(key, JSON.stringify(val)); //添加
  },
  remove(key) {
    localStorage.removeItem(key); //删除本地数据
  },
  clear() {
    localStorage.clear(); //清空
  }
};

